if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl
    } = window.wp.components;

    registerBlockType('custom-gutenberg/experiences-slide', {
        // built-in attributes
        title: 'Experiences Slide',
        description: 'Custom Experiences Slide',
        icon: 'slides',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            backgroundImage: {
                type: 'string',
                default: ''
            }, 
            title: {
                type: 'string',
                default: ''
            },
            description: {
                type: 'string',
                default: ''
            },
            viewMore: {
                type: 'string',
                default: 'Explore more'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                link,
                backgroundImage,
                title,
                description,
                viewMore
            } = attributes;

            // custom functions
            function onLinkChange (link) {
                setAttributes({link: link});
            };

            function onSelectImage (image) {
                setAttributes({backgroundImage: image.sizes.full.url});
            }

            function onTitleChange(title) {
                setAttributes({title: title});
            }

            function onDescriptionChange(description) {
                setAttributes({description: description});
            }

            function onViewMoreChange(viewMore) {
                setAttributes({viewMore: viewMore});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Link' }>
                        <p><strong>Enter url: (ex: /putovanja)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                    </PanelBody>
                    <PanelBody title={ 'Background Image Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ backgroundImage } 
                            render={ ( { open } ) => (
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                            ) } />
                    </PanelBody>
                    <PanelBody title={ 'Slide Content' }>
                        <p><strong>Title</strong></p>
                        <TextControl value={ title } onChange={ onTitleChange }></TextControl>
                        <p><strong>Description</strong></p>
                        <TextControl value={ description } onChange={ onDescriptionChange }></TextControl>
                        <p><strong>Button</strong></p>
                        <TextControl value={ viewMore } onChange={ onViewMoreChange }></TextControl>
                    </PanelBody>
                </InspectorControls>
                ,
                <div className="een-slider__slide">
                    <div className="cover-image" style={{ height: 350, backgroundImage: `url(${backgroundImage})` }}>
                        <div className="container">
                            <div className="experience-box">
                                <RichText 
                                    key="editable" 
                                    tagName="h2" 
                                    className="title"
                                    placeholder="Title" 
                                    value={ title }
                                    onChange={ onTitleChange } />
                                <RichText 
                                    key="editable" 
                                    tagName="p" 
                                    className="description"
                                    placeholder="DESCRIPTION" 
                                    value={ description }
                                    onChange={ onDescriptionChange }/>
                                <RichText 
                                    key="editable" 
                                    tagName="a" 
                                    className="btn btn-primary"
                                    placeholder="CONTENT" 
                                    value={ viewMore }
                                    onChange={ onViewMoreChange }/>
                            </div>
                        </div>
                    </div>
                </div>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                backgroundImage,
                title,
                description,
                viewMore
            } = attributes;

            return (
                <div className="keen-slider__slide" >
                    <div className="lozad cover-image" data-background-image={ backgroundImage }>
                        <div className="container">
                            <div className="experience-box">
                                <h2 className="title">{ title }</h2>
                                <RichText.Content tagName="p" className="description" value={ description } />
                                <a href={ link } className="btn btn-primary">{ viewMore }</a>
                            </div>
                        </div>
                    </div>
                </div>
            );
        },
    });
}